/* FIZAC — mejoras de lectura en la descripción del producto (solo presentación) */
(function () {
  function mejorar() {
    document.querySelectorAll('.productView-tab .tab-content').forEach(function (tab) {
      tab.querySelectorAll('ul li').forEach(function (li) {
        if (li.dataset.fz) return;
        var t = li.textContent, i = t.indexOf(':');
        var k = t.slice(0, i).trim(), v = t.slice(i + 1).trim();
        // Solo pares cortos tipo dato ("Marca: Milwaukee"); las frases largas con dos puntos se quedan como texto
        if (i > 0 && i < 32 && k.split(/\s+/).length <= 4 && v.length > 0 && v.length <= 80 && li.children.length === 0 && !(v.length > 30 && /^[a-záéíóúñ]/.test(v))) {
          li.dataset.fz = '1';
          li.classList.add('fz-kv');
          li.innerHTML = '<span class="fz-k"></span><span class="fz-v"></span>';
          li.firstChild.textContent = t.slice(0, i).trim();
          li.lastChild.textContent = t.slice(i + 1).trim();
        }
      });
      tab.querySelectorAll('p').forEach(function (p) {
        if (/^Disponible en FIZAC/i.test(p.textContent.trim())) p.classList.add('fz-note');
      });
    });
  }
  if (document.readyState !== 'loading') mejorar(); else document.addEventListener('DOMContentLoaded', mejorar);
})();

/* Talla obligatoria: en productos con opción de talla no se preselecciona ninguna;
   el botón de compra queda bloqueado hasta que el cliente elige (salvo que la URL traiga ?variant=). */
(function () {
  var box = document.querySelector('[data-fz-talla="variantes"]');
  if (!box) return;
  var fs = [].slice.call(document.querySelectorAll('variant-radios fieldset, variant-selects .product-form__input')).filter(function (f) {
    var l = f.querySelector('legend, label');
    return l && /talla|size|n[uú]mero/i.test(l.textContent);
  })[0];
  if (!fs) return;
  var btn = box.querySelector('button[type="submit"], [name="add"]');
  var aviso = document.createElement('p');
  aviso.className = 'fz-talla-aviso';
  aviso.textContent = 'Elige tu talla para agregar al carrito.';
  function bloquear(on) {
    box.classList.toggle('fz-talla-pendiente', on);
    if (btn) btn.disabled = on;
  }
  if (!/[?&]variant=/.test(location.search)) {
    [].forEach.call(fs.querySelectorAll('input[type="radio"]'), function (r) { r.checked = false; });
    var sel = fs.querySelector('select');
    if (sel) { var o = new Option('Elige tu talla', ''); o.disabled = true; sel.insertBefore(o, sel.firstChild); sel.value = ''; }
    box.insertBefore(aviso, box.firstChild);
    bloquear(true);
  }
  fs.addEventListener('change', function () {
    if (aviso.parentNode) aviso.parentNode.removeChild(aviso);
    fs.classList.remove('fz-talla-error');
    bloquear(false);
  });
  function frenar(e) {
    if (!box.classList.contains('fz-talla-pendiente')) return;
    if (e.type === 'click' && !e.target.closest('button, .shopify-payment-button')) return;
    e.preventDefault(); e.stopPropagation();
    fs.classList.add('fz-talla-error');
    fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  box.addEventListener('click', frenar, true);
  box.addEventListener('submit', frenar, true);
})();

/* "Explora por tipo" dentro de una marca: cuenta cuántos productos de la marca hay en cada tipo
   y oculta los tipos sin productos. Los resultados se guardan en la sesión para no repetir consultas. */
(function () {
  var nav = document.querySelector('[data-fz-subcats][data-brand]');
  if (!nav) return;
  var chips = [].slice.call(nav.querySelectorAll('[data-fz-count-url]'));
  var loading = nav.querySelector('[data-fz-loading]');
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('fzConteo') || '{}'); } catch (e) {}
  function guardar() { try { sessionStorage.setItem('fzConteo', JSON.stringify(cache)); } catch (e) {} }
  function pintar(a, n) {
    if (n > 0) { a.querySelector('[data-fz-count]').textContent = n; a.hidden = false; }
    else a.remove();
  }
  Promise.all(chips.map(function (a) {
    var url = a.getAttribute('data-fz-count-url');
    if (cache[url] != null) { pintar(a, cache[url]); return Promise.resolve(); }
    return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var m = html.match(/data-fz-total>(\d+)</);
      var n = m ? parseInt(m[1], 10) : 0;
      cache[url] = n; pintar(a, n);
    }).catch(function () { a.hidden = false; });
  })).then(function () {
    guardar();
    if (loading) loading.remove();
    if (!nav.querySelector('[data-fz-count-url]')) nav.querySelector('.fz-subcats__list').insertAdjacentHTML('beforeend', '<span class="fz-subcats__loading">No hay otras categorías para esta marca.</span>');
  });
})();

/* Formulario de contacto: mensajes de validación junto a cada campo (sin enviar si hay errores). */
(function () {
  [].forEach.call(document.querySelectorAll('form.contact-form'), function (form) {
    form.setAttribute('novalidate', 'novalidate');
    function revisar(input) {
      var field = input.closest('.form-field');
      if (!field) return true;
      var err = field.querySelector('.fz-field-error');
      var ok = input.checkValidity() && !(input.required && !input.value.trim());
      field.classList.toggle('fz-invalid', !ok);
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok) {
        if (!err) { err = document.createElement('p'); err.className = 'fz-field-error'; err.id = input.id + '-error'; field.appendChild(err); }
        err.textContent = input.value.trim() ? (input.getAttribute('data-fz-msg') || input.validationMessage) : 'Este campo es obligatorio.';
        input.setAttribute('aria-describedby', err.id);
      } else if (err) { err.remove(); input.removeAttribute('aria-describedby'); }
      return ok;
    }
    var campos = form.querySelectorAll('input:not([type=hidden]):not([type=submit]), textarea');
    [].forEach.call(campos, function (i) {
      i.addEventListener('blur', function () { if (i.value) revisar(i); });
      i.addEventListener('input', function () { if (i.closest('.fz-invalid')) revisar(i); });
    });
    form.addEventListener('submit', function (e) {
      var primero = null;
      [].forEach.call(campos, function (i) { if (!revisar(i) && !primero) primero = i; });
      if (primero) { e.preventDefault(); e.stopImmediatePropagation(); primero.focus(); }
    }, true);
  });
  var msg = document.querySelector('.fz-form-message');
  if (msg) setTimeout(function () { msg.scrollIntoView({ block: 'center' }); msg.focus({ preventScroll: true }); }, 300);
})();

/* Barra de herramientas de colección/búsqueda: si no muestra nada (p. ej. búsqueda con 1 resultado), se oculta
   para no dejar una franja vacía con borde. Se vuelve a evaluar al cambiar el tamaño de la ventana. */
(function () {
  var bars = document.querySelectorAll('toolbar-item.toolbar');
  if (!bars.length) return;
  function evaluar() {
    [].forEach.call(bars, function (t) {
      t.classList.remove('fz-toolbar-vacia');
      var visible = [].some.call(t.children, function (c) { return c.offsetHeight > 0; });
      t.classList.toggle('fz-toolbar-vacia', !visible);
    });
  }
  evaluar();
  window.addEventListener('resize', evaluar);
  document.addEventListener('shopify:section:load', evaluar);
})();

/* Encabezado fijo (al hacer scroll): usa los mismos iconos de Mi cuenta y Carrito que el encabezado superior. */
(function () {
  var nav = document.querySelector('.header-navigation');
  if (!nav) return;
  ['account', 'cart'].forEach(function (k) {
    var src = document.querySelector('.header-utility .header__icon--' + k + ' svg');
    var dst = nav.querySelector('.header__icon--' + k + ' svg');
    if (src && dst) {
      var c = src.cloneNode(true);
      c.removeAttribute('id');
      dst.parentNode.replaceChild(c, dst);
    }
  });
  nav.classList.add('fz-iconos-fijos');
})();

/* FIZAC — texto de existencias al cambiar de variante (mismo criterio que snippets/fz-existencias.liquid) */
window.fzStock = function (n) {
  n = parseInt(n, 10) || 0;
  if (n > 10) return '<span class="fz-stock fz-stock--ok">Más de 10 piezas en existencia</span>';
  if (n > 1) return '<span class="fz-stock fz-stock--ok">' + n + ' piezas en existencia</span>';
  return '<span class="fz-stock fz-stock--ok">1 pieza en existencia</span>';
};

/* FIZAC — Lupa del encabezado (arriba y con el menú fijo): el tema escucha el clic solo sobre el SVG original
   (que se reemplazó por el ícono nuevo), así que reenviamos el clic del cuadro de la lupa a ese SVG. */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('.section-header-navigation .header__icon--search');
  if (!btn || !window.jQuery) return;
  var svg = btn.querySelector('.icon-search');
  if (!svg) return;
  e.preventDefault();
  e.stopPropagation();
  window.jQuery(svg).trigger('click');
  setTimeout(function () {
    var inp = btn.closest('.section-header-navigation').querySelector('input[name="q"]');
    if (inp) inp.focus();
  }, 150);
}, true);

/* FIZAC — Cerrar el buscador con la tecla Esc */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var sec = document.querySelector('.section-header-navigation.sticky-search-menu-open');
  if (!sec) return;
  var btn = sec.querySelector('.header-search-close');
  if (btn) btn.click();
});

/* Filtro "Disponibilidad": el índice de filtros de Shopify puede traer conteos desfasados respecto al inventario real.
   Se piden los conteos reales (mismos filtros de la URL + cada opción de disponibilidad) a la sección fz-conteo. */
(function () {
  var cache = {};
  function contar(valor) {
    var u = new URL(location.href);
    u.searchParams.delete('filter.v.availability'); u.searchParams.delete('page'); u.searchParams.delete('section_id');
    u.searchParams.append('filter.v.availability', valor);
    u.searchParams.set('section_id', 'fz-conteo');
    var k = u.pathname + u.search;
    if (!cache[k]) cache[k] = fetch(k, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var m = t.match(/data-fz-total>(\d+)</); return m ? parseInt(m[1], 10) : null; })
      .catch(function () { return null; });
    return cache[k];
  }
  function aplicar() {
    document.querySelectorAll('[data-fz-avail]:not([data-fz-ok])').forEach(function (sp) {
      sp.setAttribute('data-fz-ok', '1');
      contar(sp.getAttribute('data-fz-avail')).then(function (n) {
        if (n === null) return;
        sp.textContent = '(' + n + ')';
        var li = sp.closest('li'), inp = li && li.querySelector('input[type="checkbox"]');
        if (inp && !inp.checked) {
          inp.disabled = n === 0;
          li.querySelectorAll('label').forEach(function (l) { l.classList.toggle('facet-checkbox--disabled', n === 0); });
        }
      });
    });
  }
  var t;
  function programar() { clearTimeout(t); t = setTimeout(aplicar, 60); }
  if (document.readyState !== 'loading') aplicar(); else document.addEventListener('DOMContentLoaded', aplicar);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { programar(); break; }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* FIZAC 2026-10-16 — Accesibilidad del carrito: el tema solo cambia el número visible del contador;
   aquí se sincroniza el texto para lectores de pantalla (con plural) y se anuncia el cambio. */
(function () {
  var S = window.cartStrings || {};
  function etiqueta(n) {
    var t = n === 1 ? S.countOne : S.countOther;
    return t ? t.replace('[count]', n) : String(n);
  }
  var vivo = null, ultimo = null, espera = null;
  function anunciar(msg) {
    if (!vivo) {
      vivo = document.createElement('div');
      vivo.className = 'visually-hidden';
      vivo.setAttribute('role', 'status');
      vivo.setAttribute('aria-live', 'polite');
      document.body.appendChild(vivo);
    }
    vivo.textContent = '';
    setTimeout(function () { vivo.textContent = msg; }, 60);
  }
  function sincronizar() {
    var nums = document.querySelectorAll('.cart-count-bubble [data-cart-count]');
    if (!nums.length) return;
    var txt = (nums[0].textContent || '').trim();
    var n = parseInt(txt, 10);
    if (isNaN(n)) return;
    var masDe99 = /\+/.test(txt);
    var lectura = masDe99 ? etiqueta(99).replace('99', txt) : etiqueta(n);
    nums.forEach(function (el) {
      var oculto = el.parentElement && el.parentElement.querySelector('.visually-hidden');
      if (oculto && oculto.textContent !== lectura) oculto.textContent = lectura;
    });
    if (ultimo !== null && ultimo !== txt) anunciar((S.updated || '[count]').replace('[count]', lectura));
    ultimo = txt;
  }
  function iniciar() {
    sincronizar();
    var obs = new MutationObserver(function () { clearTimeout(espera); espera = setTimeout(sincronizar, 80); });
    document.querySelectorAll('.cart-count-bubble [data-cart-count]').forEach(function (el) {
      obs.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
})();

/* FIZAC 2026-10-19 — Guarda la nota del carrito (datos de factura) al salir del campo, para que llegue al pedido
   aunque el cliente pague con Shop Pay o PayPal desde el carrito. */
(function () {
  var ultimo = null;
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.tagName !== 'TEXTAREA' || el.name !== 'note') return;
    var nota = el.value;
    if (nota === ultimo) return;
    fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: nota })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      ultimo = nota;
      document.querySelectorAll('textarea[name="note"]').forEach(function (t) { if (t !== el) t.value = nota; });
    }).catch(function (err) { console.warn('FIZAC: no se pudo guardar la nota del carrito', err); });
  });
})();

/* FIZAC 2026-10-19 — Nombres accesibles en español para botones de apps (WhatsApp de Carthike y formulario de Judge.me).
   Solución definitiva pendiente: configurar estos textos en cada app. Solo cambia aria-label en inglés conocido. */
(function () {
  var MAPA = { 'Contact us': 'Escríbenos por WhatsApp', 'Close review form': 'Cerrar formulario de reseña', 'Previous step': 'Paso anterior', 'Next step': 'Paso siguiente' };
  var SEL = '#chwhatsapp-btn[aria-label], .jdgm-write-review-modal [aria-label]';
  function traducir() {
    document.querySelectorAll(SEL).forEach(function (el) {
      var es = MAPA[el.getAttribute('aria-label')];
      if (es) el.setAttribute('aria-label', es);
    });
  }
  function iniciar() {
    traducir();
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; traducir(); });
    }).observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();

/* FIZAC 2026-10-19 — «Necesito factura» en el carrito: guarda los datos como atributos del carrito (llegan al pedido).
   Solo recopila datos; no emite CFDI. No pone datos fiscales en la URL ni los envía a analítica. */
(function () {
  var CAMPOS = ['RFC', 'Razón social', 'C.P. fiscal', 'Uso de CFDI', 'Régimen fiscal', 'Correo factura'];
  var cola = Promise.resolve();
  function guardar(attrs) {
    cola = cola.then(function () {
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    });
    return cola;
  }
  function estado(caja, texto) {
    var s = caja.querySelector('[data-fz-factura-estado]');
    if (s) s.textContent = texto;
  }
  function validar(el) {
    var v = el.value.trim();
    if (el.dataset.fzAttr === 'RFC') { v = v.toUpperCase().replace(/\s+/g, ''); el.value = v; }
    if (!v) return { ok: true, v: v };
    if (el.dataset.fzAttr === 'RFC' && !/^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test(v)) return { ok: false, msg: 'Revisa el RFC: deben ser 12 caracteres (empresa) o 13 (persona física).' };
    if (el.dataset.fzAttr === 'C.P. fiscal' && !/^\d{5}$/.test(v)) return { ok: false, msg: 'El código postal fiscal debe tener 5 dígitos.' };
    if (el.type === 'email' && !el.checkValidity()) return { ok: false, msg: 'Revisa el correo para la factura.' };
    return { ok: true, v: v };
  }
  function sincronizar(origen, attr, valor) {
    document.querySelectorAll('[data-fz-factura] [data-fz-attr="' + attr + '"]').forEach(function (el) {
      if (el === origen) return;
      if (el.type === 'checkbox') el.checked = valor === 'Sí'; else el.value = valor;
    });
  }
  function mostrar(caja, si) {
    var chk = caja.querySelector('[data-fz-attr="Factura"]');
    var campos = caja.querySelector('.fz-factura__campos');
    if (campos) campos.hidden = !si;
    if (chk) chk.setAttribute('aria-expanded', si ? 'true' : 'false');
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.dataset || !el.dataset.fzAttr) return;
    var caja = el.closest('[data-fz-factura]');
    if (!caja) return;
    var attrs = {};
    if (el.dataset.fzAttr === 'Factura') {
      var si = el.checked;
      document.querySelectorAll('[data-fz-factura]').forEach(function (c) { mostrar(c, si); });
      sincronizar(el, 'Factura', si ? 'Sí' : '');
      attrs.Factura = si ? 'Sí' : '';
      if (!si) CAMPOS.forEach(function (k) { attrs[k] = ''; });
      if (si) { var primero = caja.querySelector('.fz-factura__campos input'); if (primero) primero.focus(); }
    } else {
      var r = validar(el);
      el.setAttribute('aria-invalid', r.ok ? 'false' : 'true');
      if (!r.ok) { estado(caja, r.msg); return; }
      attrs[el.dataset.fzAttr] = r.v;
      sincronizar(el, el.dataset.fzAttr, r.v);
    }
    estado(caja, 'Guardando…');
    guardar(attrs).then(function () {
      estado(caja, attrs.Factura === '' ? 'Listo: sin factura.' : 'Datos de factura guardados.');
    }).catch(function (err) {
      console.warn('FIZAC: no se pudieron guardar los datos de factura', err);
      estado(caja, 'No se pudieron guardar tus datos. Revisa tu conexión e inténtalo de nuevo.');
    });
  });
})();

/* FIZAC 2026-10-19 — Botones del carrito lateral (Indicaciones, Cupón…) usables con teclado: Enter y Espacio. */
document.addEventListener('keydown', function (e) {
  var t = e.target;
  if (!t || !t.classList || !t.classList.contains('fz-tool')) return;
  if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
});
/* Enter dentro de «Necesito factura» guarda el campo en vez de enviar el formulario del carrito (que lleva al pago). */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' || !e.target || !e.target.closest || !e.target.closest('[data-fz-factura]')) return;
  if (e.target.tagName === 'INPUT' && e.target.type !== 'checkbox') { e.preventDefault(); e.target.dispatchEvent(new Event('change', { bubbles: true })); }
});

/* FIZAC 2026-10-19 — Barra de búsqueda visible: abre el buscador existente del encabezado (no crea otro formulario). */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-fz-abrir-buscador]');
  if (!btn) return;
  var summaries = Array.prototype.slice.call(document.querySelectorAll('details-modal.header__search summary'));
  var s = summaries.filter(function (x) { return x.offsetParent !== null || x.getClientRects().length; })[0] || summaries[0];
  if (!s) { window.location.href = (window.routes && window.routes.search_url) || '/search'; return; }
  var det = s.closest('details');
  window.fzBuscadorOrigen = btn;
  e.preventDefault(); e.stopPropagation();
  // Se abre después de que termine este clic: si no, el tema lo toma como «clic fuera» y cierra el buscador.
  setTimeout(function () {
    if (!det || !det.hasAttribute('open')) s.click();
    setTimeout(function () {
      // En celular el tema abre el buscador en un panel lateral con su propio campo: se enfoca el campo visible.
      var inp = Array.prototype.slice.call(document.querySelectorAll('input[type="search"]')).filter(function (i) { return i.offsetParent !== null; })[0];
      if (inp) { inp.focus(); if (inp.value) inp.select(); }
    }, 120);
  }, 0);
}, true);

/* FIZAC 2026-10-19 — Cálculo de envío en el carrito con la API de tarifas de Shopify (tarifas reales de Envia.com).
   Recuerda el código postal y el estado solo en esta pestaña (sessionStorage) para recalcular al cambiar el carrito. */
(function () {
  var KEY = 'fz-envio';
  function leer() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function guardar(v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* sin almacenamiento: solo no se recuerda */ } }
  var dinero = function (p) { return '$' + Number(p).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var turno = 0;
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function consultar(cp, edo) {
    var q = new URLSearchParams({ 'shipping_address[zip]': cp, 'shipping_address[country]': 'Mexico', 'shipping_address[province]': edo });
    return fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST' }).then(function (r) {
      if (r.status !== 202 && !r.ok) return r.json().then(function (j) { throw new Error(Object.values(j || {}).join(' ') || ('HTTP ' + r.status)); });
      var intentos = 0;
      return (function esperar() {
        return fetch('/cart/async_shipping_rates.json?' + q).then(function (r2) {
          if (r2.status === 200) return r2.json().then(function (j) { if (j) return j.shipping_rates || []; throw new Error('vacío'); }).catch(function () { return reintentar(); });
          if (r2.status === 202) return reintentar();
          return r2.json().then(function (j) { throw new Error(Object.values(j || {}).join(' ') || ('HTTP ' + r2.status)); });
        });
        function reintentar() {
          if (++intentos > 12) throw new Error('La paquetería tardó demasiado en responder.');
          return new Promise(function (ok) { setTimeout(ok, 1200); }).then(esperar);
        }
      })();
    });
  }
  function calcular(caja, cp, edo) {
    var res = caja.querySelector('[data-fz-envio-res]');
    var mio = ++turno;
    res.innerHTML = '<p class="fz-envio__cargando">Consultando tarifas…</p>';
    // Si la paquetería responde sin tarifas, se reintenta una vez: a veces la primera consulta llega vacía.
    consultar(cp, edo).then(function (rates) {
      if (rates.length || mio !== turno) return rates;
      return new Promise(function (ok) { setTimeout(ok, 1500); }).then(function () { return consultar(cp, edo); });
    }).then(function (rates) {
      if (mio !== turno) return;
      if (!rates.length) { res.innerHTML = '<p>¿No aparece una opción de envío para tu pedido? <a href="https://wa.me/524929248024?text=' + encodeURIComponent('Hola FIZAC, quiero cotizar el envío de mi pedido a mi código postal: ' + cp) + '" target="_blank" rel="noopener">Contáctanos por WhatsApp</a> y te ayudamos a cotizarlo.</p>'; return; }
      rates.sort(function (a, b) { return Number(a.price) - Number(b.price); });
      res.innerHTML = '<ul>' + rates.map(function (r) {
        var d = r.delivery_days && r.delivery_days.length ? r.delivery_days : null;
        var dias = d ? (d[0] === d[d.length - 1] ? d[0] + (d[0] === 1 ? ' día hábil' : ' días hábiles') : d[0] + ' a ' + d[d.length - 1] + ' días hábiles') + ' de tránsito' : '';
        return '<li><span>' + esc(r.presentment_name || r.name) + (dias ? '<small>' + dias + '</small>' : '') + '</span><b>' + dinero(r.price) + '</b></li>';
      }).join('') + '</ul>';
    }).catch(function (err) {
      if (mio !== turno) return;
      console.warn('FIZAC: no se pudo calcular el envío', err);
      res.innerHTML = '<p>No pudimos calcular el envío en este momento' + (err && err.message && err.message.length < 140 ? ' (' + esc(err.message) + ')' : '') + '. Verás el costo exacto en la pantalla de pago.</p>';
    });
  }
  function enviar(f) {
    var cp = f.querySelector('input').value.trim(), edo = f.querySelector('select').value;
    var res = f.querySelector('[data-fz-envio-res]');
    if (!/^\d{5}$/.test(cp)) { res.innerHTML = '<p>Escribe un código postal de 5 dígitos.</p>'; f.querySelector('input').focus(); return; }
    if (!edo) { res.innerHTML = '<p>Elige el estado.</p>'; f.querySelector('select').focus(); return; }
    guardar({ cp: cp, edo: edo });
    calcular(f, cp, edo);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fz-envio-calcular]');
    if (b) { e.preventDefault(); enviar(b.closest('[data-fz-envio-form]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var f = e.target.closest('[data-fz-envio-form]');
    if (f && (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT')) { e.preventDefault(); enviar(f); }
  });
  // Al volver a pintar el carrito (agregar, quitar, cambiar cantidades), recalcula si ya se había consultado.
  function restaurar() {
    var v = leer(); if (!v) return;
    document.querySelectorAll('[data-fz-envio]').forEach(function (d) {
      var f = d.querySelector('[data-fz-envio-form]');
      if (!f || f.dataset.fzListo) return;
      f.dataset.fzListo = '1';
      f.querySelector('input').value = v.cp; f.querySelector('select').value = v.edo;
      d.open = true; calcular(f, v.cp, v.edo);
    });
  }
  document.addEventListener('cart-update', function () { setTimeout(restaurar, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restaurar); else restaurar();
})();

/* FIZAC 2026-10-19 — Escape cierra el panel abierto del carrito lateral (Indicaciones, Cupón…) y devuelve el foco al botón. */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var abierto = document.querySelector('.popup-toolDown.show');
  if (!abierto) return;
  e.preventDefault(); e.stopPropagation();
  abierto.classList.remove('show');
  var pc = document.querySelector('.previewCart'); if (pc) pc.classList.remove('active-tool');
  if (window.fzToolOrigen && document.contains(window.fzToolOrigen)) window.fzToolOrigen.focus();
}, true);

/* FIZAC 2026-10-19 — Escape cierra el buscador del celular (panel lateral) y devuelve el foco a quien lo abrió. */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape' || !document.body.classList.contains('open_search_mobile')) return;
  var cerrar = document.querySelector('[data-search-close-sidebar]');
  if (cerrar) cerrar.click(); else document.body.classList.remove('open_search_mobile');
  var origen = document.querySelector('[data-fz-abrir-buscador]:not([hidden])');
  var ic = Array.prototype.slice.call(document.querySelectorAll('details-modal.header__search summary')).filter(function (x) { return x.offsetParent; })[0];
  var d = document.querySelector('details-modal.header__search details[open]'); if (d) d.removeAttribute('open');
  (window.fzBuscadorOrigen && document.contains(window.fzBuscadorOrigen) ? window.fzBuscadorOrigen : (ic || origen) || document.body).focus();
});
/* Escritorio: al cerrar con Escape el buscador abierto desde la barra, el foco regresa a la barra. */
document.addEventListener('keyup', function (e) {
  if (e.key !== 'Escape' || !window.fzBuscadorOrigen) return;
  setTimeout(function () {
    if (!document.body.classList.contains('open_search_menu') && !document.querySelector('details-modal.header__search details[open]') && document.contains(window.fzBuscadorOrigen)) {
      window.fzBuscadorOrigen.focus(); window.fzBuscadorOrigen = null;
    }
  }, 60);
});

/* FIZAC 2026-10-28 — Cantidades del carrito (página /cart y carrito lateral).
   Antes la cantidad escrita a mano solo se guardaba al salir del campo (evento change): en celular el cliente
   escribía «3», veía el total viejo y al recargar volvía a 1. Ahora:
   - se guarda al dejar de escribir (0.8 s), al salir del campo o con Enter; los botones +/− siguen igual;
   - las solicitudes van en fila (una a la vez) y gana la última cantidad escrita;
   - se usa la clave de la línea (no su posición), así no se mueve otra línea si cambia el orden;
   - si Shopify rechaza la cantidad, el campo regresa a lo que realmente quedó guardado;
   - «Pagar» espera a que termine el último guardado. */
(function () {
  var SEL = 'input[data-cart-quantity]';
  var timers = {}, cola = Promise.resolve(), pendientes = 0, deseado = {};
  function fuera(i) { return !i || i.closest('.quick-order-list__contents'); }
  function aviso(msg) {
    try { if (window.halo && halo.showWarning) return halo.showWarning(msg); } catch (e) {}
    try { if (typeof showWarning === 'function') return showWarning(msg, window.warningTime || 4000); } catch (e) {}
  }
  function sincroniza(key, q) {
    document.querySelectorAll(SEL + '[data-line="' + CSS.escape(key) + '"]').forEach(function (x) {
      if (document.activeElement !== x || deseado[key] === undefined) x.value = q;
    });
  }
  function pinta(cart) {
    var b = document.body;
    try {
      // window.halo lo expone theme.js (FIZAC 2026-10-28) para redibujar con el mismo código del tema.
      if (b.classList.contains('template-cart') && window.halo && halo.updateCart) halo.updateCart(cart);
      if (b.classList.contains('cart-sidebar-show') && window.halo && halo.updateSidebarCart) halo.updateSidebarCart(cart);
    } catch (e) {}
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
  }
  function guarda(input) {
    var key = input.dataset.line, raw = String(input.value).trim();
    if (!key) return;
    if (raw === '' || !/^\d+$/.test(raw)) return; // vacío o inválido: se resuelve al salir del campo
    var q = Math.min(parseInt(raw, 10), 999);
    var stock = parseInt(input.dataset.inventoryQuantity, 10);
    var wrap = input.closest('cart-update-quantity');
    var pol = wrap && window['cart_selling_array_' + wrap.dataset.product];
    if (pol && pol[input.dataset.cartQuantityId] === 'deny' && stock > 0 && q > stock) {
      q = stock; aviso((window.cartStrings && cartStrings.addProductOutQuantity || 'Solo hay [maxQuantity] disponibles').replace('[maxQuantity]', stock));
    }
    deseado[key] = q; pendientes++;
    document.documentElement.classList.add('fz-cart-guardando');
    cola = cola.then(function () {
      if (deseado[key] !== q) return; // ya hay una cantidad más nueva para esta línea
      return fetch('/cart/change.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (cart) { if (deseado[key] === q) { delete deseado[key]; sincroniza(key, q); pinta(cart); } })
        .catch(function (err) {
          delete deseado[key];
          aviso((err && (err.description || err.message)) || 'No se pudo actualizar la cantidad. Intenta de nuevo.');
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var it = cart.items.filter(function (x) { return x.key === key; })[0];
            sincroniza(key, it ? it.quantity : 0); pinta(cart);
          });
        });
    }).catch(function () {}).then(function () {
      if (--pendientes <= 0) { pendientes = 0; document.documentElement.classList.remove('fz-cart-guardando'); }
    });
  }
  var enEspera = {};
  function programa(input, ms) {
    var key = input.dataset.line;
    clearTimeout(timers[key]); enEspera[key] = input;
    timers[key] = setTimeout(function () { delete timers[key]; delete enEspera[key]; guarda(input); }, ms);
  }
  // Se captura antes que el manejador original (jQuery) para que no haya dos solicitudes por el mismo cambio.
  document.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest(SEL);
    if (fuera(i)) return;
    e.stopImmediatePropagation();
    programa(i, 0);
  }, true);
  document.addEventListener('input', function (e) {
    var i = e.target.closest && e.target.closest(SEL);
    if (!fuera(i)) programa(i, 800);
  }, true);
  document.addEventListener('keydown', function (e) {
    var i = e.target.closest && e.target.closest(SEL);
    if (!fuera(i) && e.key === 'Enter') { e.preventDefault(); programa(i, 0); i.blur(); }
  }, true);
  document.addEventListener('focusout', function (e) {
    var i = e.target.closest && e.target.closest(SEL);
    if (fuera(i)) return;
    if (!/^\d+$/.test(String(i.value).trim())) { // vacío o inválido: regresa a lo guardado
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var it = cart.items.filter(function (x) { return x.key === i.dataset.line; })[0];
        i.value = it ? it.quantity : 1;
      });
    }
  }, true);
  function listo() {
    // Manda ya lo que estaba esperando (escrito hace menos de 0.8 s) y lo que tenga el foco.
    Object.keys(timers).forEach(function (k) { clearTimeout(timers[k]); delete timers[k]; var i = enEspera[k]; delete enEspera[k]; if (i) guarda(i); });
    var a = document.activeElement;
    if (a && a.matches && a.matches(SEL) && deseado[a.dataset.line] === undefined) guarda(a);
    return cola;
  }
  // «Pagar»: espera a que se guarde la última cantidad.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#cart-checkout, #cart-sidebar-checkout, [name="checkout"], a[href$="/checkout"]');
    if (!btn) return;
    var activo = document.activeElement && document.activeElement.matches && document.activeElement.matches(SEL);
    if (!pendientes && !Object.keys(timers).length && !activo) return;
    e.preventDefault(); e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    listo().then(function () { window.location.href = '/checkout'; });
  }, true);
  window.addEventListener('pagehide', function () { if (Object.keys(timers).length) listo(); });
})();
